import currentUserStore from 'stores/CurrentUserStore';
import { isAuth0Flow } from '../../authProvider';

export const requirements = {
  requiredPermissions: ['Support', 'Admin', 'SuperAdmin'],
};

export const verifier = () => {
  if (isAuth0Flow()) return false;

  const allowed = ['Support', 'Admin', 'SuperAdmin'];
  const {
    userStore: { uamGranularPermissionsActive, permissionLevel },
  } = currentUserStore;

  return !uamGranularPermissionsActive && allowed.includes(permissionLevel);
};
